import { render, staticRenderFns } from "./OtherZonedSchools.vue?vue&type=template&id=6045b738&scoped=true&lang=pug&"
import script from "./OtherZonedSchools.vue?vue&type=script&lang=js&"
export * from "./OtherZonedSchools.vue?vue&type=script&lang=js&"
import style0 from "./OtherZonedSchools.vue?vue&type=style&index=0&id=6045b738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6045b738",
  null
  
)

export default component.exports